<fieldset class="fieldset fieldset-select-date">

  <form class="form-group" [formGroup]="parent">
    <div class="desktop-tooltip">
      @if (question.questionText) {
        <div class="question-style normal-ques-style mt-30">
          <span> {{question.questionText}} </span>
        </div>
      }
      @if (question.helpText) {
        <div class="info-icon d-view">
          @if (question.helpText) {
            <app-tool-tip-notification [uwQuesForWA]="question" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)"
              [childId]="'dateComp'" [tooltipData]="initializeToolTipDateComp(question)">
            </app-tool-tip-notification>
          }
        </div>
      }
      @if (question.helpText) {
        <div class="info-icon mt-view">
          @if (question.helpText) {
            <app-tool-tip-notification [uwQuesForWA]="question" (lifestyleInfoEmitter)="lifestyleInfoReceiver($event)"
              [childId]="'dateComp'" [tooltipData]="initializeToolTipDateComp(question)"
              (displayMobileTooltipEmitter)="displayDrpTooltipMessage(question)">
            </app-tool-tip-notification>
          }
        </div>
      }
      @if (displayTooltipAlert) {
        <app-modal [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
        (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
      }
    </div>
    <div class="col-md-12 calender-container">
      <div class="form-field">
        <label for="select-id-2" class="form-label access">Month</label>

        <div class="form-field-select">
          <select [ngClass]="{'invalid-error-border': (parent.get(controlNameForMonth).touched && parent.get(controlNameForMonth).errors)}"
            class="form-control" id="{{domId+ '-Month'}}" aria-invalid="false" aria-labelledby="legend-select-date" [(ngModel)]="selectedMonth"
            (change)="onChangeOfDropdown($event)" [formControlName]="controlNameForMonth">
            <option value="">Month</option>
            @for (month of Months; track month) {
              <option [ngValue]="month.value">
              {{month.key}}</option>
            }
          </select>
          <i class="icon icon-chevron-down" aria-hidden="true"></i>
        </div>
      </div>

      <div class="form-field">
        <label for="select-id-3" class="form-label access">Year</label>

        <div class="form-field-select">
          <select [ngClass]="{'invalid-error-border': (parent.get(controlNameForYear).touched && parent.get(controlNameForYear).errors)}"
            class="form-control" id="{{domId+ '-Year'}}" aria-invalid="false" aria-labelledby="legend-select-date" [(ngModel)]="selectedYear"
            (change)="onChangeOfDropdown($event)" [formControlName]="controlNameForYear">
            <option value="">Year </option>
            @for (year of Years; track year) {
              <option [ngValue]="year">
              {{year}}</option>
            }
          </select>

          <i class="icon icon-chevron-down" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </form>
</fieldset>

@if ((parent.get(controlNameForMonth).touched && parent.get(controlNameForMonth).errors)
  || (parent.get(controlNameForYear).touched && parent.get(controlNameForYear).errors)) {
  <div class="top-10 form-validation-error">
    <i class="icon icon-error" aria-hidden="true"></i>
    @if (((parent.get(controlNameForMonth).errors
      && parent.get(controlNameForMonth).errors.required) || (parent.get(controlNameForYear).errors
      && parent.get(controlNameForYear).errors.required))) {
      <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">
      Please make a selection</p>
    }
    @if ((isMonthAndYearBothSelected()) && ((parent.get(controlNameForMonth).errors
      && parent.get(controlNameForMonth).errors.notValid) || (parent.get(controlNameForYear).errors
      && parent.get(controlNameForYear).errors.notValid))) {
      <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">
      Please select a valid date</p>
    }
    @if ((isMonthAndYearBothSelected()) && ((parent.get(controlNameForYear).errors
      && parent.get(controlNameForYear).errors.startDateInvalid))) {
      <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">
      Please select a valid date</p>
    }
    @if ((isMonthAndYearBothSelected()) &&  ((parent.get(controlNameForMonth).errors
      && parent.get(controlNameForMonth).errors.futureDateInvalid) || (parent.get(controlNameForYear).errors
      && parent.get(controlNameForYear).errors.futureDateInvalid))) {
      <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">
      Please select a valid date</p>
    }
  </div>
}